import React from 'react';
import Form from 'react-bootstrap/Form'
import jwtClient from '../../JwtClient';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from 'react-select';


export class PickupPointAddressNPI extends React.Component {
    regionsUrl = '/api/v1/address/npi/regions';
    state = {
        regions: [], // {'value': 1, 'label': 'Kievskaya oblast'}
        cities: [],
        streets: [],
    };

    componentDidMount() {
        jwtClient.get(this.regionsUrl)
            .then((response) => {
                this.setState({regions: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            });
    }

    translate = data => {
        return data.map((item) => {
            item['label'] = item['name'];
            delete item['name'];
            item['value'] = item['id'];
            delete item['id'];
            return item;
        }).sort((a, b) => a.label.localeCompare(b.label));
    };

    getIdByLabel = (label, array) => {
        for (let i of array) {
            if (label === i.label) {
                return i.value;
            }
        }
    };

    loadCities = regionLabel => {
        const regionId = this.getIdByLabel(regionLabel, this.state.regions);
        return jwtClient.get(this.regionsUrl, {params: {region_id: regionId}})
            .then((response) => {
                this.setState({cities: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            })
    };

    loadStreets = (regionName, cityName) => {
        const regionId = this.getIdByLabel(regionName, this.state.regions);
        const cityId = this.getIdByLabel(cityName, this.state.cities);
        return jwtClient.get(this.regionsUrl, {params: {city_id: cityId, region_id: regionId}})
            .then((response) => {
                this.setState({streets: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            })

    };

    render() {
        const {
            values,
            errors,
            setFieldValue,
        } = this.props;
        return (
            <div>
                <Form.Group>
                    <Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm="6">
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.npiPickupPointAddress.region}
                                        onChange={(region) => {
                                            setFieldValue('npiPickupPointAddress.region', region);
                                            setFieldValue('npiPickupPointAddress.city', null);
                                            setFieldValue('npiPickupPointAddress.street', null);
                                            this.setState({streets: []});
                                            this.loadCities(region.label);
                                        }}
                                        options={this.state.regions}
                                        placeholder="Region"
                                        isInvalid={true}
                                    />
                                    {/*// TODO here we use JSON to stringify object with 'value' attr that is returned by YUP during validation*/}
                                    {/*// After YUP is deleted do not forget to remove json stringify, it will be unnecessary*/}
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.npiPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.region)
                                        }
                                    </small>
                                </Col>
                                <Col sm="6">
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.npiPickupPointAddress.city}
                                        onChange={(city) => {
                                            setFieldValue('npiPickupPointAddress.city', city);
                                            setFieldValue('npiPickupPointAddress.street', null);
                                            this.loadStreets(values.npiPickupPointAddress.region.label, city.label);
                                        }}
                                        options={this.state.cities}
                                        placeholder="City"
                                        isDisabled={!values.npiPickupPointAddress.region}
                                    />
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.npiPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.city)
                                        }
                                    </small>
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm="12">
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.npiPickupPointAddress.street}
                                        onChange={(street) => {
                                            setFieldValue('npiPickupPointAddress.street', street);
                                        }}
                                        options={this.state.streets}
                                        placeholder="Street"
                                        isDisabled={!values.npiPickupPointAddress.city}
                                    />
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.npiPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.street)
                                        }
                                    </small>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form.Group>
                </Form.Group>
            </div>
        );
    }
}
